module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( "replace" === context ) { 
__p+=' <h4>'+
((__t=( i18n.tc( "SubscriptionPackageSelection", "Replace subscription package" ) ))==null?'':__t)+
'</h4> ';
 if ( showCurrent ) { 
__p+=' <h5>'+
((__t=( i18n.tc( "SubscriptionPackageSelection", "Current subscription package" ) ))==null?'':__t)+
'</h5><section class="existing payment-block open block"><div class="block"><span class="name">'+
((__t=( currentPackName ))==null?'':__t)+
'</span></div> ';
 if ( !isPackageFree ) { 
__p+=' <div><dl> ';
 if ( fixedPrice ) { 
__p+=' <dt class="monthly-price-label">'+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "Total price:")))==null?'':__t)+
'</dt><dd class="montly-price">'+
((__t=( currentPackagePrice ))==null?'':__t)+
' '+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "(tax incl.)")))==null?'':__t)+
'</dd> ';
 } else { 
__p+=' <dt class="monthly-price-label">'+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "Monthly price:")))==null?'':__t)+
'</dt><dd class="montly-price">'+
((__t=( currentMonthlyPrice ))==null?'':__t)+
' '+
((__t=( i18n.tc("SubscriptionPackageRadioButton", "(tax incl.)")))==null?'':__t)+
'</dd> ';
 } 
__p+=' </dl></div> ';
 } 
__p+=' </section> ';
 } 
__p+=' ';
 } 
__p+=' ';
 if ( prepaid ) { 
__p+=' <h5>'+
((__t=( i18n.tc("SubscriptionPackageSelection", "Select a dealer agreement") ))==null?'':__t)+
'</h5> ';
 } else { 
__p+=' <h5>'+
((__t=( i18n.tc("SubscriptionPackageSelection", "Select a subscription plan") ))==null?'':__t)+
'</h5> ';
 } 
__p+=' ';
 if ( !hidePromotion ) { 
__p+=' <fieldset class="fold"><div><label for="selection-promo-code-input">'+
((__t=( i18n.tc("SubscriptionPackageSelection", "Promotional code:") ))==null?'':__t)+
'</label> <input type="text" id="selection-promo-code-input" data-input="selection-promo-code"></div><div data-container="promo-feedback"></div></fieldset><fieldset class="button-wrap"><button class="primary" data-click="selection-promotion" disabled="disabled">'+
((__t=( i18n.tc("SubscriptionPackageSelection", "Submit") ))==null?'':__t)+
'</button></fieldset><hr> ';
 } 
__p+=' <fieldset><div class="subscription-wrap" data-region="selection-container"></div></fieldset><fieldset class="button-wrap"><button data-click="selection-cancel">'+
((__t=( i18n.tc("SubscriptionPackageSelection", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="selection-submit" disabled="disabled">'+
((__t=( i18n.tc("SubscriptionPackageSelection", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
